module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    class: {
      'table-active': _vm.missionSlotSelected
    },
    on: {
      "click": function($event) {
        if (!$event.ctrlKey) { return null; }
        _vm.toggleMissionSlotSelection($event)
      }
    }
  }, [(_vm.anyMissionSlotSelected) ? _c('td', [(_vm.missionSlotSelected) ? _c('i', {
    staticClass: "fa fa-check-square text-muted",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.missionSlotDetails.orderNumber))]), _vm._v(" "), _c('td', [(!_vm.missionSlotDetails.restrictedCommunity && !_vm.missionSlotDetails.reserve && !_vm.missionSlotDetails.blocked) ? _c('div', [_c('i', {
    class: _vm.difficultyIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.missionSlotDetails.title) + "\n      "), _vm._l((_vm.missionSlotRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "16px"
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.missionSlotDetails.restrictedCommunity || _vm.missionSlotDetails.reserve || _vm.missionSlotDetails.blocked) ? _c('b-popover', {
    attrs: {
      "content": _vm.titlePopoverContent,
      "triggers": ['hover']
    }
  }, [_c('span', {
    class: _vm.titleColor,
    domProps: {
      "innerHTML": _vm._s(_vm.formattedTitle)
    }
  }), _vm._v(" "), _vm._l((_vm.missionSlotRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "16px"
      }
    })
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.missionSlotDetails.blocked) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.blocked')))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && _vm.missionSlotDetails.assignee) ? _c('span', [_c('router-link', {
    staticClass: "text-success font-weight-bold",
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionSlotDetails.assignee.uid
        }
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.formatUserWithTag(_vm.missionSlotDetails.assignee)) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && _vm.missionSlotDetails.externalAssignee) ? _c('span', {
    staticClass: "text-success font-weight-bold font-italic"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.externalAssignee))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && !_vm.missionSlotDetails.externalAssignee && (!_vm.missionSlotDetails.registrationCount || _vm.missionSlotDetails.registrationCount <= 0)) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(("" + (this.$tc('mission.slot.assignee.registration', 0)))))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && !_vm.missionSlotDetails.externalAssignee && _vm.missionSlotDetails.registrationCount && _vm.missionSlotDetails.registrationCount > 0) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(((this.missionSlotDetails.registrationCount) + " " + (this.$tc('mission.slot.assignee.registration', this.missionSlotDetails.registrationCount > 1 ? 2 : 1)))))]) : _vm._e()]), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('td', [_vm._v(_vm._s(_vm.missionSlotDetails.description))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot actions"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotDetailsModal",
      modifiers: {
        "missionSlotDetailsModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.prepareMissionSlotDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n      ")]), _vm._v(" "), (_vm.loggedIn && !_vm.missionSlotDetails.registrationUid && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotRegistrationModal",
      modifiers: {
        "missionSlotRegistrationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.missionSlotDetails.blocked || !_vm.canRegisterForSlot
    },
    on: {
      "click": _vm.setMissionSlotDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-ticket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.register')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.missionSlotDetails.registrationUid && !_vm.hasMissionEnded) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-eraser",
      "yes-class": "btn btn-warning",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.unregister'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionSlotRegistration
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.unregister')) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n        ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b866d120"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotlistGroupSlotsRow.vue
// module id = 571
// module chunks = 0